import { SURVEY_EVENTS, SURVEY_DATA_SOURCE } from '@/packages/components/hook/useSurvey'

/**
 * 组件信息
 */
export const info = {
  name: 'xy-survey-btn', // 组件名
  type: 'component-business', // 组件类型
  label: '问卷表单按钮', // 组件label
  icon: 'icon-xy-survey-btn', // 组件图标
  defaultWidth: 0, // 组件默认宽度
  defaultHeight: 0 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  noView: { type: Boolean, default: true }, // 是否不可见
  activityId: { type: String, default: '' }, // 活动id
  dialogUUID: { type: String, default: '' }, // 弹窗uuid
  requestStatistic: { type: Boolean, default: true }
}

/**
 * 组件开放方法事件
 */
export const events = SURVEY_EVENTS

/**
 * 组件开放数据源
 */
export const dataSource = SURVEY_DATA_SOURCE

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-survey-btn' // 表单组件
  }
]
